const s = {
  name: "Bug",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M26.3,4.1C27.4,5.4,28,7.1,28,9h5c2.8,0,5-2.2,5-5V2h2v2c0,3.5-2.6,6.4-6,6.9V21h6v2h-6c0,3-0.9,5.7-2.5,8H33
			c3.9,0,7,3.1,7,7v2h-2v-2c0-2.8-2.2-5-5-5h-3.2c-2.5,2.5-6,4-9.8,4s-7.3-1.5-9.8-4H7c-2.8,0-5,2.2-5,5v2H0v-2c0-3.9,3.1-7,7-7h1.5
			C6.9,28.7,6,26,6,23H0v-2h6V10.9C2.6,10.4,0,7.5,0,4V2h2v2c0,2.8,2.2,5,5,5h5c0-1.9,0.6-3.6,1.7-4.9L11,1.4L12.4,0l2.7,2.7
			C16.4,1.6,18.1,1,20,1s3.6,0.6,4.9,1.7L27.6,0L29,1.4L26.3,4.1z M20,3c-3.3,0-6,2.7-6,6h12C26,5.7,23.3,3,20,3z M8,12.4V23
			c0,6.3,4.8,11.4,11,12V23.4L8,12.4z M9.4,11L20,21.6L30.6,11H9.4z M32,12.4l-11,11v11.5c6.2-0.5,11-5.7,11-12V12.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Bug
};
